import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import store from "./store";
import { Provider } from "react-redux";
import FrameTopNav from "./components/FrameTopNav";
import FrameLeftNav from "./components/FrameLeftNav";
import "./index.css";
import { send, post, get, put, patch, deleteUrl } from './Common/api';

// "Export" to ASP.NET MVC Project
window.VancoFoodAdmin = window.VancoFoodAdmin || {};
window.VancoFoodAdmin.FrameTopNav = FrameTopNav;
window.VancoFoodAdmin.FrameLeftNav = FrameLeftNav;
window.VancoFoodAdmin.Api = { send, get, post, put, patch, deleteUrl };
window.ReactDOM = ReactDOM;
window.React = React;

// Allow ASP.NET MVC Project to suppress rendering
if (!window.doNotRenderReactApp) {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}
